import { DocumentStaticFile, FeatureCardProps } from '@interfaces/KnowledgeTransfer';
import { useTranslate } from '@translations/useTranslate';

import firstFeatureImage from '@assets/images/firstFeature.png';
import secondFeatureImage from '@assets/images/secondFeature.png';
import thiredFeature from '@assets/images/thiredFeature.png';
import fourthFeature from '@assets/images/fourthFeature.png';

import CompanyProfileEn from '@assets/documents/Company-Profile-En.pdf';
import CompanyProfileAr from '@assets/documents/Company-Profile-Ar.pdf';
import TOCBookEn from '@assets/documents/TOC_Booklet_Final.pdf';
import IMSEn from '@assets/documents/IMS_First-EN.pdf';
import IMSAr from '@assets/documents/IMS_First-AR.pdf';
import TawalCodeOfWthics2023 from '@assets/documents/TAWAL_2023_Sustainability_Report_Arabic.pdf';
import TawalCodeOfWthics2022 from '@assets/documents/TAWAL_2022_Sustainability_Report_Arabic.pdf';
import TawalCodeOfWthics2024 from '@assets/documents/TAWAL 2024 Sustainability Report - Arabic.pdf';
import TawalWhilePaper1 from '@assets/documents/Revolutionizing-connectivity-The-Strategic-Advantage-of Neutral-Host Providers-in-Telecom-Evolution-En.pdf';
import TawalWhitePaper2 from '@assets/documents/NAVIGATING-THROUGH-THE 5G-MMWAVE-ECONOMICS-BY-REVOLUTIONIZING-THE-TELECOM-LEGACY.pdf';
import TawalSustanibility2022En from '@assets/documents/TAWAL_2022_Sustainability_Report_English.pdf';
import TawalSustanibility2023En from '@assets/documents/TAWAL_2023_Sustainability_Report_English.pdf';
import TawalSustanibility2024En from '@assets/documents/TAWAL 2024 Sustainability Report - English.pdf';
import TawalSustanibility2025En from '@assets/documents/TAWAL_2025_Sustainability_Report_English.pdf';
import TawalSustanibility2025Ar from '@assets/documents/TAWAL_2025_Sustainability_Report_Arabic.pdf';
import BaseStationsPower from '@assets/documents/BaseStations-Power.xlsx';
import EnergyGJ from '@assets/documents/Energy_GJ_2022_2023.xlsx';
import WasteManagment from '@assets/documents/Waste Management and Recycling.xlsx';
import TawalSuppliersCodeofConductPolicy from '@assets/documents/TAWAL_Suppliers_Code_of_Conduct_Policy_Final.pdf';
import TawalSupplierConflictofInterestPolicy from '@assets/documents/TAWAL_Supplier_Conflict_of_Interest_Policy_Final.pdf';
import TawalCodeofEthicsPolicy from '@assets/documents/TAWAL_Code_of_Ethics_Policy_Final.pdf';

export const useGetStaticDocuments = () => {
  const { t } = useTranslate();
  const staticFilesEn: Array<DocumentStaticFile> = [
    {
      documentTitle: 'Company Profile',
      documentDescription:
        'The booklet includes an overview about TAWAL, our vision, mission and how we manage our business, well highlighting what sets us apart and the solutions that we offer to our clients, alongside our executive team.',
      fileTypes: ['PDF'],
      link: CompanyProfileEn,
      fileName: 'Company-Profile-En.pdf',
      language: 'English',
      category: 'Business and Services',
      tags: ['corporate-profile', 'about-us'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'Tower Operations Center & Customer Interface',
      documentDescription:
        'This booklet includes an overview about the Tower Operations Center & Customer Interface (TOC), which works 24/7 to manage the infrastructure in the Kingdom with the latest technology.',
      fileTypes: ['PDF'],
      link: TOCBookEn,
      fileName: 'toc-book-En.pdf',
      language: 'English',
      category: 'Business and Services',
      tags: ['operations', 'customer-interface'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'TAWAL integrated management system (IMS)',
      documentDescription:
        'This policy includes TAWAL’s commitment to implement principles of the integrated management system to achieve TAWAL’s vision, mission, and values',
      fileTypes: ['PDF'],
      link: IMSEn,
      fileName: 'IMS_First-EN.pdf',
      language: 'English',
      category: 'Governance and Compliance',
      tags: ['operations-management'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'Code of Ethics',
      documentDescription:
        'This code of ethics includes TAWAL’s commitment to its customers, communities and all stakeholders and aims to deliver the highest ethical and professional standards.',
      fileTypes: ['PDF'],
      link: TawalCodeofEthicsPolicy,
      fileName: 'TAWAL_Code_of_Ethics_Policy_Final.pdf',
      language: 'English',
      category: 'People and Place',
      tags: ['compliance', 'ethics'],
      date: '30/07/2026',
    },
    {
      documentTitle: 'Supplier Code of Conduct',
      documentDescription:
        'This supplier code of conduct demonstrates TAWAL’s commitment to conducting business with the highest standards of ethics and integrity.',
      fileTypes: ['PDF'],
      link: TawalSuppliersCodeofConductPolicy,
      fileName: 'TAWAL_Suppliers_Code_of_Conduct_Policy_Final.pdf',
      language: 'English',
      category: 'Governance and Compliance',
      tags: ['supplier', 'ethics'],
      date: '30/07/2026',
    },
    {
      documentTitle: 'TAWAL White Paper |',
      documentDescription:
        'This white paper addresses the strategic advantage of neutral host providers in telecom evolution.',
      fileTypes: ['PDF'],
      link: TawalWhilePaper1,
      fileName:
        'Revolutionizing-connectivity-The-Strategic-Advantage-of Neutral-Host Providers-in-Telecom-Evolution-En.pdf',
      language: 'English',
      category: 'Innovation and Strategy',
      tags: ['industry-insights', 'strategy'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'TAWAL White Paper ||',
      documentDescription:
        'This white paper navigates through the 5G-mmWave economics by revolutionizing the telecom legacy.',
      fileTypes: ['PDF'],
      link: TawalWhitePaper2,
      fileName:
        'NAVIGATING-THROUGH-THE 5G-MMWAVE-ECONOMICS-BY-REVOLUTIONIZING-THE-TELECOM-LEGACY.pdf',
      language: 'English',
      category: 'Innovation and Strategy',
      tags: ['industry-insights', 'strategy'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'Sustainability Report 2022',
      documentDescription:
        'This report includes the most prominent initiatives that contribute to environmental sustainability part of our strategy. And the efforts and achievements made by TAWAL in this field.',
      fileTypes: ['PDF'],
      link: TawalSustanibility2022En,
      fileName: 'TAWAL_2022_Sustainability_Report_English.pdf',
      language: 'English',
      category: 'Sustainability and Responsibility',
      tags: ['sustainability', 'environment'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'Sustainability Report 2023',
      documentDescription:
        'This 2023 report showcases the execution of our sustainability strategy, our journey towards building a more resilient organization, and our efforts at fostering a more sustainable future.',
      fileTypes: ['PDF'],
      link: TawalSustanibility2023En,
      fileName: 'TAWAL_2023_Sustainability_Report_English.pdf',
      language: 'English',
      category: 'Sustainability and Responsibility',
      tags: ['sustainability', 'environment'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'Sustainability Report 2024',
      documentDescription:
        'The Sustainability report for the year 2024 highlights the implementation of our sustainability strategy and key milestones across Environmental, Social, and Governance pillars, reinforcing our commitment to caring for the environment, enabling an inclusive society, and upholding transparent and accountable governance.',
      fileTypes: ['PDF'],
      link: TawalSustanibility2024En,
      fileName: 'TAWAL 2024 Sustainability Report - English.pdf',
      language: 'English',
      category: 'Sustainability and Responsibility',
      tags: ['sustainability', 'environment'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'Sustainability Report 2025',
      documentDescription:
        'The 2025 Sustainability Report highlights TAWAL’s key achievements and initiatives across environmental, social, and governance areas, along with the progress made in advancing its sustainability practices, demonstrating the company’s commitment to transparency and accountability and its continued efforts to create a positive and sustainable impact.',
      fileTypes: ['PDF'],
      link: TawalSustanibility2025En,
      fileName: 'TAWAL_2025_Sustainability_Report_English.pdf',
      language: 'English',
      category: 'Sustainability and Responsibility',
      tags: ['sustainability', 'environment'],
      date: '01/10/2026',
    },
    {
      documentTitle: 'Base Stations Power',
      documentDescription:
        'This dataset provides annual figures from 2021 to 2023 on the total number of telecommunications base stations and their primary energy sources in use. It includes counts of base stations powered by renewable energy, diesel (dual DG only), and other energy types. The data reflects trends in network expansion and the transition toward more sustainable energy solutions.',
      fileTypes: ['CSV'],
      link: BaseStationsPower,
      fileName: 'BaseStations-Power.xlsx',
      language: 'English',
      category: 'Business and Services',
      tags: ['power', ' energy-infrastructure'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'Energy Consumption Data (2022–2023)',
      documentDescription:
        'This dataset provides annual energy consumption figures for the years 2022 and 2023. It includes electricity consumption from buildings, direct energy use from generators, and indirect energy use (purchased electricity). The data also summarizes total direct and indirect energy consumption, measured in gigajoules (GJ), to support energy performance tracking and sustainability reporting.',
      fileTypes: ['CSV'],
      link: EnergyGJ,
      fileName: 'Energy_GJ_2022_2023.xlsx',
      language: 'English',
      category: 'Sustainability and Responsibility',
      tags: ['energy-consumption', 'sustainability-metrics'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'Waste Generation and Diversion Data (2022–2023)',
      documentDescription:
        "This dataset presents information on waste generation, recycling, and disposal from 2022 to 2023. It includes total waste generated, the amount and percentage of waste recycled or diverted from disposal, and the waste directed to disposal. The data is provided in tonnes and percentages, highlighting the organization's waste management performance and progress toward sustainability goals.",
      fileTypes: ['CSV'],
      link: WasteManagment,
      fileName: 'Waste Management and Recycling.xlsx',
      language: 'English',
      category: 'Sustainability and Responsibility',
      tags: ['waste-management', 'recycling'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'TAWAL Supplier Conflict of Interest Policy',
      documentDescription:
        'The Supplier Conflict of Interest Policy includes TAWAL’s approach to identifying, managing, and disclosing conflicts of interest in dealings with the Company and its stakeholders. It applies to individuals, suppliers, and contractors, including their owners and executives.',
      fileTypes: ['PDF'],
      link: TawalSupplierConflictofInterestPolicy,
      fileName: 'TAWAL_Supplier_Conflict_of_Interest_Policy_Final.pdf',
      language: 'English',
      category: 'Governance and Compliance',
      tags: ['supplier', 'conflict-of-interest'],
      date: '30/07/2026',
    },
  ];
  const staticFilesAr: Array<DocumentStaticFile> = [
    {
      documentTitle: 'نبذة عن الشركة',
      documentDescription:
        'يشمل الكتيب نبذة عن توال، ويوضح رؤيتنا ورسالتنا وكيفية إدارتنا لأعمالنا، بالإضافة إلى أبرز مايميزنا ونبذة عن الحلول التي نقدمها لعملائنا، وكذلك فريقنا التنفيذي.',
      fileTypes: ['PDF'],
      link: CompanyProfileAr,
      fileName: 'Company-Profile-Ar.pdf',
      language: 'العربية',
      category: 'الأفراد والمكان',
      tags: ['الملف التعريفي للشركة', 'عن الشركة'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'مركز التحكم بالشبكة وعمليات العملاء',
      documentDescription:
        'يشمل هذا الكتيب نظرة عامة على مركز التحكم بالشبكة وعمليات العملاء في توال والذي يعمل على مدار الساعة لإدارة البنية التحتية في المملكة بأحدث التقنيات.',
      fileTypes: ['PDF'],
      link: TOCBookEn,
      fileName: 'toc-book-Ar.pdf',
      language: 'العربية',
      category: 'الأفراد والمكان',
      tags: ['العمليات', 'واجهة العملاء'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'بيان سياسة نظام الإدارة المتكامل (IMS)',
      documentDescription:
        'تشمل هذه السياسة التزام شركة توال بتنفيذ مبادئ نظام الإدارة المتكامل لتحقيق رؤية ورسالة وقيم توال.',
      fileTypes: ['PDF'],
      link: IMSAr,
      fileName: 'IMS_First-AR.pdf',
      language: 'العربية',
      category: 'الحوكمة والامتثال',
      tags: ['إدارة العمليات'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'ميثاق الأخلاقيات',
      documentDescription:
        'يشمل ميثاق الأخلاقيات التزام توال بالنزاهة اتجاه عملائنا ومجتمعنا، وكل من له علاقة بعمل توال وتهدف إلى إيصال أسمى المعايير الأخلاقية والمهنية.',
      fileTypes: ['PDF'],
      link: TawalCodeofEthicsPolicy,
      fileName: 'TAWAL_Code_of_Ethics_Policy_Final.pdf',
      language: 'العربية',
      category: 'الأفراد والمكان',
      tags: ['الامتثال', 'الأخلاقيات'],
      date: '30/07/2026',
    },
    {
      documentTitle: 'تقرير الاستدامة 2022',
      documentDescription:
        'يشمل هذا التقرير أهم مبادرات تعزيز الاستدامة البيئية كجزء من استراتيجيتنا. وأبرز الجهود والإنجازاتنا التي قامت بها الشركة في هذا المجال.',
      fileTypes: ['PDF'],
      link: TawalCodeOfWthics2022,
      fileName: 'TAWAL_2022_Sustainability_Report_Arabic.pdf',
      language: 'العربية',
      category: 'المسؤولية والاستدامة',
      tags: ['الاستدامة', 'البيئة'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'تقرير الاستدامة 2023',
      documentDescription:
        'يعرض هذا التقرير لعام 2023 تنفيذ استراتيجيتنا للاستدامة، ورحلتنا نحو بناء منظمة أكثر مرونة، بالإضافة إلى جهودنا في تعزيز مستقبل أكثر استدامة.',
      fileTypes: ['PDF'],
      link: TawalCodeOfWthics2023,
      fileName: 'TAWAL_2023_Sustainability_Report_Arabic.pdf',
      language: 'العربية',
      category: 'المسؤولية والاستدامة',
      tags: ['الاستدامة', 'البيئة'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'تقرير الاستدامة 2024',
      documentDescription:
        'يسلط هذا التقرير لعام 2024 الضوء على تنفيذ استراتيجيتنا للاستدامة وأبرز إنجازاتنا في بناء منظمة أكثر مرونة، من خلال مبادراتنا المؤثرة في محاور البيئة والمجتمع والحوكمة، بما يعكس التزامنا بالشفافية، وتمكين مجتمع شامل، وحماية البيئة.',
      fileTypes: ['PDF'],
      link: TawalCodeOfWthics2024,
      fileName: 'TAWAL_2024_Sustainability_Report_Arabic.pdf',
      language: 'العربية',
      category: 'المسؤولية والاستدامة',
      tags: ['الاستدامة', 'البيئة'],
      date: '13/1/2026',
    },
    {
      documentTitle: 'تقرير الاستدامة 2025',
      documentDescription:
        'يستعرض تقرير الاستدامة لعام 2025 أبرز إنجازات توال ومبادراتها في مجالات البيئة والمجتمع والحوكمة، إلى جانب التقدم الذي أحرزته الشركة في تعزيز ممارسات الاستدامة، والتزامها بالشفافية والمساءلة، ومواصلة تحقيق أثر إيجابي ومستدام.',
      fileTypes: ['PDF'],
      link: TawalSustanibility2025Ar,
      fileName: 'TAWAL_2025_Sustainability_Report_Arabic.pdf',
      language: 'العربية',
      category: 'المسؤولية والاستدامة',
      tags: ['الاستدامة', 'البيئة'],
      date: '01/10/2026',
    },
    {
      documentTitle: 'سياسة توال لتعارض المصالح للموردين',
      documentDescription:
        'تشمل سياسة تعارض المصالح للموردين لدى توال نهج الشركة في تحديد وإدارة والإفصاح عن حالات تعارض المصالح في التعاملات مع الشركة وأصحاب المصلحة. وتنطبق على الأفراد والموردين والمتعاقدين، بما في ذلك ملاكهم والإدارة التنفيذية.',
      fileTypes: ['PDF'],
      link: TawalSupplierConflictofInterestPolicy,
      fileName: 'TAWAL_Supplier_Conflict_of_Interest_Policy_Final.pdf',
      language: 'العربية',
      category: 'الحوكمة والامتثال',
      tags: [' الموردين', 'تعارض المصالح'],
      date: '30/07/2026',
    },
  ];
  const knowLedgeCenterPoints: Array<FeatureCardProps> = [
    {
      title: t('knowledgecenyer.page.static.card1.header'),
      description: t('knowledgecenyer.page.static.card1.description'),
      imageUrl: firstFeatureImage,
      alternateName: 'firstFeatureImage',
    },
    {
      title: t('knowledgecenyer.page.static.card2.header'),
      description: t('knowledgecenyer.page.static.card2.description'),
      imageUrl: secondFeatureImage,
      alternateName: 'secondFeatureImage',
    },
    {
      title: t('knowledgecenyer.page.static.card3.header'),
      description: t('knowledgecenyer.page.static.card3.description'),
      imageUrl: thiredFeature,
      alternateName: 'thiredFeature',
    },
    {
      title: t('knowledgecenyer.page.static.card4.header'),
      description: t('knowledgecenyer.page.static.card4.description'),
      imageUrl: fourthFeature,
      alternateName: 'fourthFeature',
    },
  ];
  return { staticFilesEn, staticFilesAr, knowLedgeCenterPoints };
};
